/**
 * Deletes all properties on the object that are assigned as undefined.
 */
export function removeUndefinedProps(obj) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (obj[key] === undefined)
            delete obj[key];
    }
    return obj;
}
